module.exports = "/assets/Inter-Light.ab15890d.woff2";